import React, { useState, useEffect } from "react";
import Text from "../../components/common/Text";
import { urlbase } from "../../constants/Constants";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router";
import { getMoreLeaderboards, getUserData } from "../../api/documents";
import { Box, Typography } from "@mui/material";

export default function Leaderboard(props) {
  //declarations

  const history = useHistory();

  if (props === undefined || props.user === undefined) history.push("/login");

  //base data
  const user = props.user;
  let position = 0;

  //use states
  const [leaderBoardList, setLeaderBoardList] = useState([]);
  const [userPosition, setUserPosition] = useState([]);
  const [isLeaderboardLoading, setIsLeaderboardLoading] = useState(false);
  const [isUserDataLoading, setIsUserDataLoading] = useState(false);
  const [count, setCount] = useState(0);

  //data fetching
  let offset = 0;
  let requestCount = 0;

  //student data
  const userStuId = user.student.id;
  const userStuTokenPoints = user.student.token_points;

  useEffect(() => {
    setIsLeaderboardLoading(true);
    setIsUserDataLoading(true);
    setCount(0);
    loadUserData();
    loadMoreLeaderboards();
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  async function loadUserData() {
    const userDataResponse = await getUserData(user.token, userStuId);
    setIsUserDataLoading(false);
    setUserPosition(userDataResponse.data);
  }

  async function loadMoreLeaderboards() {
    const moreleaderboardsResponse = await getMoreLeaderboards(
      user.token,
      offset,
      20
    );
    const newLeaderboard = moreleaderboardsResponse.data;
    setIsLeaderboardLoading(false);
    setLeaderBoardList((oldLeaderboard) => [
      ...oldLeaderboard,
      ...newLeaderboard,
    ]);

    if (newLeaderboard.length < 20) setCount(1);

    offset += 20;
    requestCount += 1;
  }

  const handleScroll = (e) => {
    if (
      window.innerHeight + e.target.documentElement.scrollTop >=
      e.target.documentElement.scrollHeight
    ) {
      loadMoreLeaderboards();
    }
  };

  const displayUserData = () => {
    let userSchool;
    let userProvince;
    let userPositionInProvince;
    let userPositionInSchool;

    //getting user data in leaderboard
    const filteredUserData = userPosition.filter((userData) => {
      return userData.id_num === user.student.id_num;
    });

    //setting user data
    filteredUserData.map((user) => {
      userProvince = user.province;
      userSchool = user.school;
    });

    //getting province data
    const filteredByProvince = userPosition.filter((provinceData) => {
      return provinceData.province === userProvince;
    });

    //setting province data
    userPositionInProvince = filteredByProvince.findIndex((position) => {
      return position.id_num === user.student.id_num;
    });

    //getting school data
    const filteredBySchool = userPosition.filter((schoolData) => {
      return schoolData.school === userSchool;
    });

    //setting school data
    userPositionInSchool = filteredBySchool.findIndex((position) => {
      return position.id_num === user.student.id_num;
    });

    return (
      <div>
        {/*student earned tokens*/}
        <div
          className="ReferenceCard"
          style={{
            backgroundColor: "white",
            color: "#00112e",
            cursor: "default",
          }}
        >
          <Text>Tokens Earned: {userStuTokenPoints}</Text>
        </div>

        {/*Position in School*/}
        <div
          className="ReferenceCard"
          style={{
            backgroundColor: "white",
            color: "#00112e",
            cursor: "default",
          }}
        >
          <Text>
            At {userSchool}: {userPositionInSchool + 1}
          </Text>
        </div>

        {/*Position in Province*/}
        <div
          className="ReferenceCard"
          style={{
            backgroundColor: "white",
            color: "#00112e",
            cursor: "default",
          }}
        >
          <Text>
            In {userProvince}: {userPositionInProvince + 1}
          </Text>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Box
        sx={{
          backgroundColor: "#212a41",
          borderRadius: "5px",
          padding: "15px",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#FBCD02",
            fontSize: "1.1rem",
            textAlign: "left",
          }}
        >
          My Stats
        </Typography>

        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        />

        {isUserDataLoading == true ? (
          <CircularProgress sx={{ color: "white !important" }} />
        ) : (
          displayUserData()
        )}
      </Box>

      <Box
        sx={{
          backgroundColor: "#212a41",
          borderRadius: "5px",
          padding: "15px",
          marginTop: "20px",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#FBCD02",

            fontSize: "1.1rem",
            textAlign: "left",
          }}
        >
          Leaderboard
        </Typography>
        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        />

        {isLeaderboardLoading == true ? (
          <CircularProgress sx={{ color: "white !important" }} />
        ) : (
          leaderBoardList.map((item, i) => {
            return (
              <div
                key={i}
                className={"ReferenceCard"}
                style={{
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderColor: "#00112e",
                  backgroundColor: "white",
                  cursor: "default",
                }}
                // onClick={() => window.open(item.url)}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginRight: "20px" }}>{(position += 1)}</div>

                  <div style={{ textAlign: "left" }}>
                    <div>{item.id_num}</div>
                    <div>{item.school}</div>
                    <div>{item.province}</div>
                  </div>
                </div>
              </div>
            );
          })
        )}

        {isLeaderboardLoading == false ? (
          count === 1 ? (
            <div style={{ color: '#FBCD02'}} >End Of Leaderboard</div>
          ) : (
            <CircularProgress sx={{ color: "white !important" }} />
          )
        ) : (
          <div></div>
        )}
      </Box>
    </div>
  );
}

//
